import { render, staticRenderFns } from "./Recurring-Pattern-Template.vue?vue&type=template&id=12c0bdda"
import script from "./Recurring-Pattern-Template.vue?vue&type=script&lang=js"
export * from "./Recurring-Pattern-Template.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports